<template>
  <div>
    <div v-if="this.hasResult">
      <v-row>
        <v-col cols="10">
          REPORT RESULTS 
        </v-col>
      </v-row>
      <v-row>
        <!--Report Summary-->
        <v-col cols="10">
          {{reportResult.reportSummary}}
        </v-col>
        <!--export icons-->
        <v-col cols="1">
          <a href="" @click.stop.prevent="exportCSV">
            <img class="exportIcons" src="../../assets/CSV-icon.svg" />
          </a>
        </v-col>
        <v-col cols="1">
          <a href="" @click.stop.prevent="exportPDF">
            <img class="exportIcons" src="../../assets/PDF-icon.svg" />
            </a>
        </v-col>
      </v-row>
      <!--report body-->
      <v-data-table
        :headers="reportResult.showColumn"
        :items="reportResult.data"
        disable-sort
        :items-per-page="rowPerPage"
        id="reportResultTable"
        hide-default-footer
        :server-items-length="reportResult.totalCount"
        :page.sync="page"
        @page-count="pageCount = $event">
        <template slot="item" slot-scope="props" style="overflow: scroll;">
          <tr>
            <td 
            v-for="header in reportResult.showColumn" 
            :key= "header.value"> 
              {{ props.item[header.name] }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <!--report total-->
      <div v-if="reportResult.total">
        <v-data-table
          v-if="reportResult.total"
          hide-default-header
          hide-default-footer
          :items="reportResult.total"
          disable-sort
          no-data-text=""
          id="reportResultTotal"
          class="mt-5">
          <template slot="item" slot-scope="props" style="overflow: scroll;">
            <tr>
              <td>{{props.item.total}}</td>
              <td>{{props.item.patientsTotal}}</td>
              <td>{{props.item.examTotal}}</td>
              <td>{{props.item.imageTotal}}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <!--report footer-->
      <select-with-button
        selection-prefix="Rows per page:"
        v-model="rowPerPage"
        :items="rowPerPageOption"
        item-value="value"
        item-text="text"
        id="rowsPerPageSelect"/>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="8"
        :color="colorHex"
        prev-icon="fas fa-caret-left"
        next-icon="fas fa-caret-right"
        id="reportPagination"></v-pagination>
    </div>
    <div v-else>
      {{this.reportResult.message}}
    </div>
    <img
      id="axis"
      style="visibility: hidden; position: absolute; left: -5000px;"
      src="../../assets/AXIS Logo for Dark Backgrounds - Grayscale.png">
    <img
      id="sonomed"
      style="visibility: hidden; position: absolute; left: -5000px;"
      src="../../assets/Sonomed Escalon Logo for Dark Backgrounds.png">
  </div>
</template>
<script>
import {ReportTypes} from "../../config/config.js";
import selectWithButton from "../controls/SelectWithButton";

  export default {
    name: "AdminPanelReportsResult",
    components: { selectWithButton },
    props: {
      reportResult: Object,
      reportType: null
    },
    data() {
      return {
        ReportTypes: ReportTypes,
        page: 1,
        pageCount: 0,
        rowPerPage:15,
        rowPerPageOption:[
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 15, text: "15" }
        ],
        options:{
          page: 1,
          rowPerPage: 15
        }
      };
    },
    methods:{
      exportPDF(){
        this.$emit("exportPDF");
      },
      exportCSV(){
        this.$emit("exportCSV");
      }
    }, 
    computed:{
      hasResult(){
        if(this.reportResult.data.length > 0){
          return true;
        }
        return false;
      }
    },  
    watch: {
      page: {
        handler(){
          this.options.page = this.page;
          this.$emit("updateReport", this.options);
        },
        deep: true
      },
      rowPerPage:{
        handler(){
          this.options.page = 1;
          this.options.rowPerPage = this.rowPerPage;
          this.$emit("updateReport", this.options);
        },
        deep: true
      }
    }
  }
</script>
<style lang="scss" scoped>
  .resultHeader{
    border-bottom: 1px solid #FFFFFF;
  }
  .exportIcons{
    height: 40px;
  }
  #reportResultTable{
    .v-select__selection--comma{
      color: #000000;
      padding-left: 7px;
    }
    .v-select__slot{
      width: 80px;
    }
  } 
</style>
<style lang="scss">
  #reportResultTable{
    .v-select__selection--comma{
      color: #000000;
      padding-left: 7px;
    }
    .v-select__slot{
      width: 80px;
    }
    td{
      width: 25%;
    }
  } 
  #reportResultTotal{
    tr{
      border-bottom: none;
    }
    td{
      width: 25%;
    }
  }
  #rowsPerPageSelect{
    width: 188px;
    display: inline-flex;
    vertical-align: middle;
    margin-top: 5px;

    .v-input__slot{
      border: none !important;
      background-color: transparent !important;
      border-radius: 0 !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      padding-right: 0;
    }
    .v-select__selections{
      color:#FFFFFF !important;
    }
  }
  #reportPagination{
    width: 60%
  }
</style>